"use client";

//* Components
import Page from '@components/global/Page';
import Subscribe from '@components/global/Subscribe';
import BlogList from '@components/cfModules/BlogList';
import HTMLContainer from '@components/global/HTMLContainer';
import PageTopSection from '@components/global/PageTopSection';

const Blog = ({ pageData, blogList }) => {
    return (
        <Page>
            <HTMLContainer>
                <PageTopSection
                    title={pageData.title}
                    subtitle={pageData.subtitle}
                    settings={pageData.settings}
                    description={pageData.description}
                />
            </HTMLContainer>

            <BlogList data={blogList} />

            <Subscribe />
        </Page>
    );
}

export default Blog;
